import qs from 'query-string';
import {useLocation} from 'react-router-dom';
import {QUERY_PARAMS_KEYS} from '../constants';

const useCurrentPageCursor = () => {
  const location = useLocation();

  const currentPage = qs.parse(location.search)?.[QUERY_PARAMS_KEYS.PAGE] || '';

  return {currentPage};
};

export default useCurrentPageCursor;
